import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { Grid, Typography, TextField, Button, Link, Divider } from '@mui/material'
import { makeStyles } from '@mui/styles';
import { texts } from "../../../../../general/texts";
import colors from '../../../../../colors';
import { useNavigate } from 'react-router-dom';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { sendGeneralRequest } from '../../../../../../features/generalRequest';
import SingleExpandedInvoice from '../../SingleExpandedInvoice';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const SelectKredoPayment = (props) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [payment, setPayment] = useState('')
    const [sumToPay, setSumToPay] = useState(0)
    const [singleInvoiceView, openSingleInvoiceView] = useState(false)
    const [transId, setTransId] = useState('')
    const [invoice, setInvoice] = useState([])
    const isSmallScreen = useMediaQuery('(max-width:600px)');

    const isButtonDisabled = () => {
        return (payment === '') || (payment === 'SumToPay' && (sumToPay === '' || sumToPay < 1))
    }

    const startTransactionKredo = () => {
        dispatch(sendGeneralRequest({ request: { token: props.data.globalDataSliceState.token, isPersonal: props.isPersonal, loanRef: props.loanData.LoanRef, type: payment === 'installment' ? 1 : payment === 'rolloverAmount' ? 2 : 3, otherAmount: sumToPay, personalNo: props.loanData.personalNo }, baseUrlKey: 'services', endpoint: 'Kredo/StartTransactionKredo' })).then(response => {
            if (response.payload.response.success) {
                setTransId(response.payload.response.transID)
                const invoiceData = {
                    'ID e klientit': props.loanData.personalNo,
                    'Klienti': props.loanData.customer,
                    'Referenca e kredisë': props.loanData.LoanRef,
                    'Vlera': response.payload.response.value,
                    'Komisioni bankar': response.payload.response.fee,
                    'Totali': response.payload.response.totalValue
                };
                setInvoice(invoiceData);
                openSingleInvoiceView(true);
            }
        })
    }

    const useStyles = makeStyles({
        mainGrid: {
            padding: '5%',
            paddingTop: '3%',
            height: isSmallScreen ? '80vh' : '450px'
        },
        utilityName: {
            color: props.data.utilityInfo.Color,
            fontSize: '1.5rem',
            fontFamily: 'GerberaBold',
            paddingTop: '3%',
            paddingLeft: '2%'
        },
        headerBox: {
            backgroundColor: colors.cyan,
            borderRadius: '100%',
            width: '70px',
            height: '70px'
        },
        fieldTitle: {
            color: colors.darkBlue,
            fontSize: '1rem',
            fontFamily: 'GerberaMedium',
            textAlign: 'left'
        },
        button: {
            width: '100%',
            color: colors.white,
            fontSize: '1rem',
            textTransform: 'none',
            background: colors.gradientOrange,
            fontFamily: 'GerberaBold',
            marginTop: 20
        },
        buttonGrid: {
            marginTop: 180,
            paddingBottom: 5
        },
        image: {
            width: '70%',
        },
        textField: {
            width: '30%'
        },
        divider: {
            background: colors.lightGray,
            width: "100%",
            marginTop: 8
        },
    })

    const classes = useStyles()

    return (
        <>
            {singleInvoiceView ? (
                <SingleExpandedInvoice utilityName={'KREDO'} invoice={invoice} globalDataSliceState={props.data.globalDataSliceState} transID={transId}/>
            ) :
                <Grid container item className={classes.mainGrid}>
                    <Grid container item md={2} xs={2} mt={2} >
                        <Link component={'button'} onClick={() => { navigate(-1) }}>
                            <ArrowBackIosNewIcon color='warning' />
                        </Link>
                    </Grid>
                    <Grid container item md={12} xs={12}>
                        <Grid container direction="row" justifyContent="center" alignItems="center" className={classes.headerBox} >
                            <img src={props.data.utilityInfo.Images.filter(image => image.color === 1 && image.size === 1)[0].imagePath} className={classes.image} />
                        </Grid>
                        <Typography className={classes.utilityName} >{props.data.utilityInfo.PublicName}</Typography>
                    </Grid>
                    <div style={{ display: 'flex', flexDirection: 'column', width: '100%', marginTop: 12 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                            <p style={{ color: colors.darkBlue, fontFamily: 'GerberaMedium', margin: '1px 0px' }}>{texts['title-client-id']}</p>
                            <p style={{ color: colors.orange, fontFamily: 'GerberaMedium', margin: '1px 0px' }}>{props.loanData.personalNo}</p>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                            <p style={{ color: colors.darkBlue, fontFamily: 'GerberaMedium', margin: '1px 0px' }}>{texts['title-client']}</p>
                            <p style={{ color: colors.orange, fontFamily: 'GerberaMedium', margin: '1px 0px' }}>{props.loanData.customer}</p>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                            <p style={{ color: colors.darkBlue, fontFamily: 'GerberaMedium', margin: '1px 0px' }}>{texts['title-loan-reference']}</p>
                            <p style={{ color: colors.orange, fontFamily: 'GerberaMedium', margin: '1px 0px' }}>{props.loanData.LoanRef}</p>
                        </div>
                    </div>
                    <Divider className={classes.divider} />
                    <p className={classes.fieldTitle}>{texts['title-select-payment']}:</p>
                    <div onClick={() => setPayment('installment')} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%', borderRadius: '8px', border: payment === 'installment' ? '2px solid #EF7a30' : '1px solid gray', marginTop: 5, padding: 20, backgroundColor: payment === 'installment' ? colors.lightOrange : colors.cyan, cursor: 'pointer' }}>
                        <p style={{ color: colors.darkBlue, fontFamily: 'GerberaMedium', margin: '1px 0px' }}>{texts['title-installment-amount']}</p>
                        <p style={{ color: payment === 'installment' ? colors.orange : colors.darkBlue, fontFamily: 'GerberaMedium', margin: '1px 0px' }}>{props.loanData.SumToPay} L</p>
                    </div>
                    {props.loanData.rolloverAmount > 0 &&
                        <div onClick={() => setPayment('rolloverAmount')} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%', borderRadius: '8px', border: payment === 'rolloverAmount' ? '2px solid #EF7a30' : '1px solid gray', marginTop: 15, padding: 20, backgroundColor: payment === 'rolloverAmount' ? colors.lightOrange : colors.cyan, cursor: 'pointer' }}>
                            <p style={{ color: colors.darkBlue, fontFamily: 'GerberaMedium', margin: '1px 0px' }}>{texts['title-rollover-amount']}</p>
                            <p style={{ color: payment === 'rolloverAmount' ? colors.orange : colors.darkBlue, fontFamily: 'GerberaMedium', margin: '1px 0px' }}>{props.loanData.rolloverAmount} L</p>
                        </div>
                    }
                    <div onClick={() => setPayment('SumToPay')} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%', borderRadius: '8px', border: payment === 'SumToPay' ? '2px solid #EF7a30' : '1px solid gray', marginTop: 15, padding: 11, backgroundColor: payment === 'SumToPay' ? colors.lightOrange : colors.cyan, cursor: 'pointer' }}>
                        <p style={{ color: colors.darkBlue, fontFamily: 'GerberaMedium', margin: '10px 0 0 10px' }}>{texts['title-pay-other-amount']}</p>
                        <TextField onChange={(e) => setSumToPay(e.target.value)} value={sumToPay} color='warning' size='small' label={'Lekë'} inputProps={{ type: 'number', min: 0 }} className={classes.textField} />
                    </div>
                    <Button disabled={isButtonDisabled()} onClick={startTransactionKredo} className={classes.button}>
                        {texts["title-pay"]}
                    </Button>
                </Grid>
            }
        </>
    )
}
export default SelectKredoPayment;